import { REPORTS_PATH } from '../../constants'
import { getByIdReduxSelector } from '../../../../redux'

export function getByIdReportSelector (id) {
  return getByIdReduxSelector(REPORTS_PATH.DATA, id)
}
